import styled from 'styled-components';

interface BaseFilterLeft {
  isCompany: boolean;
}

export const Container = styled.header`
  width: 18%;
  display: flex;
  height: auto;
  padding: 0.5em;

  @media (max-width: 990px) {
    width: 100%;
    padding: 0;
  }

  @media (max-width: 320px) {
    padding: 0.5rem;
  }
`;

export const PanelFilter = styled.div<BaseFilterLeft>`
  width: -webkit-fill-available;
  background: ${({ theme }) => theme.colors.background};
  padding: 1rem;
  border-radius: 1rem;
  display: flex;
  flex-direction: column;

  .btnBorderless {
    display: flex;
    gap: 0.2rem;
    border: none;
    align-items: center;
    border-radius: 1rem;
    outline: none;
    background-color: transparent;
    color: ${({ theme }) => theme.colors.tertiary_500};
    transition: opacity 0.5s;

    :hover {
      opacity: 0.5;
      background-color: ${({ theme }) => theme.colors.background_white};
    }
    svg {
      fill: ${({ theme }) => theme.colors.tertiary_500};
    }
  }

  .headerFilter {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.2rem;

    .header-title {
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }

    h1 {
      color: ${({ theme }) => theme.colors.primary};
      font-size: 1.5rem;
      font-weight: 600;
    }

    svg {
      width: 1.5rem;
      color: ${({ theme }) => theme.colors.primary};
    }
  }

  .contentFilter {
    h2 {
      color: ${({ theme }) => theme.colors.secondary};
      font-size: 1.2rem;
      font-weight: 600;
    }

    .containerDistricts {
      display: flex;
      gap: 1rem;

      .uf {
        width: 40%;
      }

      .district {
        width: 60%;
      }
    }

    .containerDistanceFilter {
      margin: 1rem 0;
      display: flex;
      flex-direction: column;
      gap: 0.2rem;

      .contentDistanceFilter {
        display: flex;
        gap: 0.5rem;
        align-items: center;
        justify-content: space-between;
        background: ${({ theme }) => theme.colors.background_white};
        border-radius: 1rem;
        width: -webkit-fill-available;
        height: 2rem;
        padding: 0.3rem 0.8rem;
        box-shadow: 0px 1px 3px #00000029;

        p {
          width: 90%;
          font-size: 1rem;
          color: ${({ theme }) => theme.colors.gray};
        }

        label {
          width: 30%;
          font-size: 1rem;
          color: ${({ theme }) => theme.colors.gray};
        }

        .MuiInputBase-root {
          max-height: 2rem;
        }

        .MuiInput-input {
          width: 100%;
          font-size: 1.2rem;
          color: ${({ theme }) => theme.colors.tertiary_500};
          height: 1.25rem;
          padding: 0;
          text-align: end;
        }
      }

      .checkedControl {
        display: flex;
        color: ${({ theme }) => theme.colors.text};
        align-items: center;
        font-size: 16px;
        font-weight: 300;
        gap: 1rem;
        justify-content: space-between;

        div {
          display: flex;
          align-items: center;
          color: ${({ theme }) => theme.colors.text};
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;

          p {
            width: 100%;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
          }
        }
      }
    }

    .containerSelect {
      margin: 1rem 0;
      display: flex;
      flex-direction: column;
      gap: 0.2rem;
      justify-content: center;
      h2 {
        display: flex;
        align-items: center;
        gap: 0.5rem;
      }
      .input {
        display: flex;
        align-items: center;
        gap: 0.5rem;
      }
    }
  }

  .containerSummary {
    display: flex;
    flex-direction: column;
    gap: 0.3rem;
    overflow-y: auto;
    height: auto;
    max-height: 8rem;

    .contentMap {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      height: 100%;

      p {
        color: ${({ theme }) => theme.colors.primary};
        font-weight: 300;
      }

      .remove {
        background: ${({ theme }) => theme.colors.error};
        color: ${({ theme }) => theme.colors.background_white};
        border: none;
        min-width: 0.5rem;
        min-height: 0.3rem;
        padding: 0.1rem 0 0 0;
        border-radius: 100%;
        font-size: 0.4rem;
        font-weight: bold;
        padding: 0.2rem;
      }
    }

    ::-webkit-scrollbar {
      width: 8px;
      background-color: ${({ theme }) => theme.colors.background_white};
      border-radius: 10px;
    }

    ::-webkit-scrollbar:horizontal {
      height: 5px;
    }

    ::-webkit-scrollbar-track,
    ::-webkit-scrollbar-track-horizontal {
      border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb,
    ::-webkit-scrollbar-thumb:horizontal {
      background-color: ${({ theme }) => theme.colors.tertiary_500};
      border-radius: 10px;
    }
  }

  .footerFilter {
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
  }

  @media (max-width: 990px) {
    width: -webkit-fill-available;

    .contentFilter {
      display: grid;
      gap: 1rem;
      ${({ isCompany }) =>
        isCompany
          ? `
        grid-template-columns: 1fr 1fr 1fr;
      `
          : `
        grid-template-columns: 1fr 1fr;
      `}
    }

    .footerFilter {
      margin-top: 1rem;
    }
  }

  @media (max-width: 700px) {
    .contentFilter {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 1rem;
    }
  }

  @media (max-width: 580px) {
    .contentFilter {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;

      .containerSelect,
      .containerDistanceFilter {
        margin: 0.5rem 0;
      }
    }
  }

  @media (max-width: 320px) {
    .footerFilter button {
      width: 100% !important;
    }
  }
`;
